export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/SA-13d134dfdf8312bf5bac33cdf8bf0f66.png";